import type {Content} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {MediaQuote} from './MediaQuote'

export type MediaQuoteProps = SliceComponentProps<Content.MediaQuoteSlice>

const MediaQuoteSlice = ({slice}: MediaQuoteProps): JSX.Element | null => (
  <MediaQuote
    backgroundImage={slice.primary.background_image}
    quote={isFilled.keyText(slice.primary.quote) ? slice.primary.quote : ''}
    authorName={isFilled.keyText(slice.primary.author_name) ? slice.primary.author_name : ''}
    authorTitle={isFilled.keyText(slice.primary.author_title) ? slice.primary.author_title : ''}
    paddingTop={slice.primary.padding_top}
    paddingBottom={slice.primary.padding_bottom}
  />
)

export default MediaQuoteSlice
